import { Typography, Modal, Card, Button, Grid }from '@mui/material';
import './styles.css';
import { useNavigate } from 'react-router-dom';
import { formatTime, formatTargetTimeFromSeconds } from '../../utils';

const FlashCardsEndModal = (props) => {
	const {isEndModalOpen, aboardSession, chosenFlashCardsData, correctAnswers, incorrectAnswers, timer, chosenFlashCardsInitNum} = props;
	let navigate = useNavigate();

	const timeTarget = Math.round(chosenFlashCardsInitNum * 4);
	const isSpeedy = timer <= timeTarget;

  return (
		<Modal
			open={isEndModalOpen}
		>
			<Card 
				className='modalCard' 
				style={{
					borderRadius: '15px', 
					minWidth: '250px', 
					backgroundImage: isSpeedy ? 'url("/assets/images/celebrate.gif")' : '', 
					backgroundSize: '100%',
					backgroundColor: ' #e9f3fb' // AliceBlue + more grey
				}}>
				<Typography variant="h6" component="h2">
					End of Flashcards Session
				</Typography>
				<Typography sx={{ mt: 2 }}>
					Initial number of questions: <strong>{chosenFlashCardsInitNum}</strong>
				</Typography>
				<Typography sx={{ mt: 2 }}>
					Total questions played: <strong>{chosenFlashCardsData.length}</strong>
				</Typography>
				<Typography sx={{ mt: 2 }}>
					Total correct answers: <strong>{correctAnswers.length}</strong>
					<img 
						src={correctAnswers.length / chosenFlashCardsData.length >= 0.8 ? "https://i.giphy.com/media/v1.Y2lkPTc5MGI3NjExeDV5aTl3ZDBpMzk5bHJ3NXJpZGVqejFkZDVwZTk1anowbWkxczdyNSZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9cw/5mUGrtcKCjKXE8Vsef/giphy.gif" : ''}
						style={{maxHeight: '40px', marginLeft: '5px'}}
						alt={correctAnswers.length / chosenFlashCardsData.length >= 0.8 ? "Correct Celebration Gif" : ''}
					/>	
				</Typography>
				<Typography sx={{ mt: 2 }}>
					Total incorrect answers: <strong>{incorrectAnswers.length}</strong>
				</Typography>
				<Typography sx={{ mt: 2 }}>
					Time spent: <strong>{formatTime(timer, 'text')}</strong>
					<img 
						src={isSpeedy ? "https://i.giphy.com/media/v1.Y2lkPTc5MGI3NjExZjVqYXkwYjk0dWE5MjBxNWg5eXZ1bzh6ZjJmamUyNTBrNXQ2d3lvcCZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9cw/jQpmYNmu2ixRGEMR9O/giphy.gif" : ''}
						style={{maxHeight: '40px', marginLeft: '5px'}}
						alt={isSpeedy ? "Rocket Gif" : ''}
					/>	
				</Typography>
				<Typography sx={{ mt: 2 }}>
					Recommended time target: <strong>{formatTargetTimeFromSeconds(timeTarget)}</strong>
				</Typography>
				<Typography sx={{ mt: 2 }}>
					{`You took ${formatTime(timer, 'text')} to finish these Flashcards. We recommended that you take ${timeTarget} seconds to finish therefore ${isSpeedy ? 'you finished with lightening speed! Hooray!' : 'you were a little slow. KEEP PRACTICING!'}`} 
				</Typography>
				<Grid justifyContent="flex-end" direction="row" container style={{marginTop: '10px'}}>
					<Button onClick={aboardSession} id='modalButton' variant="contained" color="secondary">New game</Button>
					<Button onClick={() => navigate('/')} id='modalButton' variant="contained" color="secondary">Home</Button>
				</Grid>
			</Card>
		</Modal>
	)
}

export default FlashCardsEndModal;